import { createActionName } from "redux/utility"

export const reducerName = "config"

export const APP_THEME = createActionName(reducerName, "APP_THEME")
export const LANGUAGE = createActionName(reducerName, "LANGUAGE")
